import PageRoutes from "./PageRoutes";
import { analytics } from "./Firebase";

function App() {
	console.log(analytics)
	return <PageRoutes />;
}

export default App;
